// extracted by mini-css-extract-plugin
export default {"fieldBox":"RadioUtil_fieldBox__lkWss","field":"RadioUtil_field__VxL4i","label":"RadioUtil_label__BMv2d","labelTxt":"RadioUtil_labelTxt__CWnRn"};